<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>
      &nbsp;&nbsp;&nbsp;{{ user == null ? 'Create User' : 'Update User' }}
    </h2>
  </div>
</div>

<form [formGroup]="userForm" (ngSubmit)="save()">
  <div class="card">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-4">
        <span class="p-float-label col-11 floatL">
          <input
            readonly="readonly"
            id="float-input"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="ehrUserName"
            class="textboxBorder-1"
          />
          <input
            id="float-hidden"
            type="hidden"
            appFormErrorMessages
            pInputText
            formControlName="ehrUserId"
          />
          <label for="float-input" class="f1"> EHR User Name</label>
        </span>

        <button
          pButton
          style="font-size: 0.7em"
          (click)="displayEhrUsernameDialog = true"
          type="button"
          icon="pi pi-list"
          class="mt-3"
        ></button>
      </div>

      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-3">
          <input
            id="float-input1"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="loginId"
            class="textboxBorder-1"
          />
          <label for="float-input1" class="f1">
            <span class="required-asteric"> * </span> Login Name</label
          >
        </span>
      </div>

      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-3">
          <p-dropdown
            id="ddlRole"
            dataKey="roleId"
            [options]="roles"
            appFormErrorMessages
            editable="false"
            optionLabel="roleName"
            placeholder="Select Role"
            class="textboxBorder-1"
            formControlName="roles"
          ></p-dropdown>
          <label for="ddlRole" class="f1">
            <span class="required-asteric"> * </span> Role</label
          >
        </span>
      </div>
    </div>
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-3">
          <input
            id="lastname"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="lname"
            class="textboxBorder-1"
          />
          <label for="float-input" class="f1">
            <span class="required-asteric"> * </span> Last Name</label
          >
        </span>
      </div>
      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-3">
          <input
            id="firstname"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="fname"
            class="textboxBorder-1"
          />
          <label for="float-input" class="f1">
            <span class="required-asteric"> * </span> First Name</label
          >
        </span>
      </div>
      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-2">
          <input
            id="middlename"
            type="text"
            pInputText
            formControlName="mi"
            class="textboxBorder-1"
                 appFormErrorMessages
          />
          <label for="float-input" class="f1"> Middle Name</label>
        </span>
      </div>
    </div>

    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-2">
          <input
            id="email"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="emailAddress"
            class="textboxBorder-1"
            autocomplete="off"
          />
          <label for="float-input" class="f1"
            ><span class="required-asteric" *ngIf="isEmailRequird"> * </span
            >Email Address</label
          >
        </span>
      </div>

      <div class="field col-12 md:col-4">
        <span class="p-float-label pl-3">
          <!--<p-inputMask id="cell" type="text" appFormErrorMessages pInputText formControlName="cellNo" mask="99-9999-9999"></p-inputMask>-->
          <input
            id="cell"
            type="text"
            appFormErrorMessages
            pInputText
            formControlName="cellNo"
            class="textboxBorder-1"
             autocomplete="off"
          />
          <label for="float-input" class="f1">
            <span class="required-asteric" *ngIf="isCellRequird"> * </span>Cell Phone</label
          >
        </span>
      </div>

      <div class="field col-12 md:col-4" *ngIf="!edited">
        <span class="p-float-label pl-3">
          <input
            id="password"
            appFormErrorMessages
            type="password"
            pPassword
            formControlName="userPassword"
            class="textboxBorder-1"
            autocomplete="new-password"
          />
          <label for="float-input" class="f1">
            <span class="required-asteric"> * </span> Password</label
          >
        </span>
      </div>

      <div class="field col-12 md:col-4" *ngIf="!edited">
        <span class="p-float-label pl-3">
          <input
            id="confirmpassword"
            appFormErrorMessages
            type="password"
            pPassword
            formControlName="confirmUserPassword"
            class="textboxBorder-1"
            autocomplete="new-password"
          />
          <label for="float-input" class="f1">
            <span class="required-asteric"> * </span> Confirm Password</label
          >
        </span>
      </div>

      <div class="col-12 md:col-2 mt-5 ml-3">
        <p-checkbox
          name="active"
          value="Y"
          label="Active"
          formControlName="active"
          binary="true"
        ></p-checkbox>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="grid">
      <!--<div class="col-12 md:col-2">
                <p-checkbox name="active" value="Y" label="Active" formControlName="active" binary="true"></p-checkbox>
            </div>-->

      <div class="col-12 md:col-3 mt-2">
        <p-checkbox
          name="allowPasswordChange"
          value="Y"
          label="Allow Password Change"
          binary="true"
          formControlName="allowPswdChg"
        ></p-checkbox>
      </div>
      <div class="col-12 md:col-3 mt-2">
        <p-checkbox
          name="forcePasswordChange"
          value="Y"
          label="Force Password Change"
          binary="true"
          formControlName="forcePswdChg"
        ></p-checkbox>
      </div>

      <div class="col-12 md:col-3 mt-2">
        <p-checkbox
          name="noEhrUser"
          value="Y"
          label="No EHR User"
          binary="true"
          [formControl]="noEHRUser"
        ></p-checkbox>
      </div>
      <div class="col-12 md:col-3 mt-2" *ngIf="showreset">
        <p-checkbox
          name="resetPwd"
          value="Y"
          label="Reset Password"
          binary="true"
          [formControl]="resetPwd"
        ></p-checkbox>
      </div>
      <!--<div class="col-12">
                <p-checkbox name="allowFinancialData" value="Y" label="Allow Financial Data" binary="true" formControlName="showFinancialData"></p-checkbox>
            </div>
            <div class="col-12">
                <p-checkbox name="allowClinicalData" value="Y" label="Allow Clinical Data" binary="true" formControlName="showClinicalData"></p-checkbox>
            </div>
            <div class="col-12">
                <p-checkbox name="allowSensitiveData" value="Y" label="Allow Sensitive Data" binary="true" formControlName="showSensitiveData"></p-checkbox>
            </div>-->
    </div>

    <div class="col-2 md:col-2 mt-2">
      <button
        pButton
        type="submit"
        label="Save"
        icon="pi pi-save"
        class="p-button-plain buttonWidth-8 fl"
      ></button>
    </div>
  </div>
</form>

<p-dialog
  header="Search EHR User"
  [(visible)]="displayEhrUsernameDialog"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '1050px', minWidth: '200px' }"
  [minY]="70"
  [maximizable]="true"
  [baseZIndex]="10000"
>
  <div class="ui-g">
    <div class="card card-w-title ui-g-12 ui-md-12 mb-3">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-4 mb-0">
          <span class="p-float-label">
            <input
              id="float-input"
              pInputText
              [(ngModel)]="EhrlastName"
              type="text"
              class="textboxBorder-1"
            />
            <label for="float-input">Last Name</label>
          </span>
        </div>

        <div class="field col-12 md:col-4 mb-0">
          <span class="p-float-label">
            <input
              id="float-input"
              pInputText
              [(ngModel)]="EhrfirstName"
              type="text"
              class="textboxBorder-1"
            />
            <label for="float-input">First Name</label>
          </span>
        </div>

        <div class="field col-12 md:col-4 mb-0">
          <button
            pButton
            type="button"
            icon="pi pi-search"
            label="Search"
            (click)="loadEhrUsernameList(1, '', '')"
            class="p-button-plain buttonWidth-8 floatL mr-2"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-times-circle"
            label="Clear"
            (click)="ClearEhrList()"
            class="p-button-plain buttonWidth-8 GreyButton"
          ></button>
        </div>
      </div>
    </div>
  </div>

  <!--<p-table *ngIf="ehrusers" [value]="ehrusers.data" [columns]="cols" [alwaysShowPaginator]="false" [paginator]="true" [rows]="10"
             [rowsPerPageOptions]="[10,20,50]" selectionMode="single" [(selection)]="selectedEhrUsername"
             (onRowSelect)="onRowSelect($event)">-->

  <p-table
    *ngIf="ehrusers"
    [resetPageOnSort]="false"
    lazy="true"
    (onLazyLoad)="nextPage($event)"
    [totalRecords]="ehrusers?.totalRecords"
    [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
    [columns]="cols"
    [alwaysShowPaginator]="false"
    [rows]="rows"
    [paginator]="true"
    [value]="ehrusers?.data"
    selectionMode="single"
    [sortOrder]="1"
    sortField="roleId"
    dataKey="roleId"
    [(selection)]="selectedEhrUsername"
    [autoLayout]="true"
    (onRowSelect)="onRowSelect($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="Showrecords == true">
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col.field"
          [hidden]="col.hidden"
        >
          {{ col.header }}
          <p-sortIcon
            [field]="col.field"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <!--<tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" [hidden]="col.hidden">
                    {{rowData[col.field]}}
                </td>
            </tr>-->
      <tr [pSelectableRow]="rowData">
        <td
          *ngFor="let col of columns; let rowIndex = index"
          [hidden]="col.hidden"
        >
          <ng-container *ngIf="col.field === 'isActive'">
            <!-- If isActive is true, display a success button -->
            <p-button
              *ngIf="rowData[col.field]"
              label="Active"
              [rounded]="true"
              severity="success"
              class="h-14"
            ></p-button>
            <!-- If isActive is false, display a danger button -->
            <p-button
              *ngIf="!rowData[col.field]"
              label="Inactive"
              [rounded]="true"
              severity="danger"
              class="h-14"
            ></p-button>
          </ng-container>
          <!-- If the column is not 'isActive', display regular data -->
          <ng-container *ngIf="col.field !== 'isActive'">
            {{ rowData[col.field] }}
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="empty" class="col-12">
      <div class="p-message-error" style="text-align: center">
        <h3 class="p-messages p-messages-summary border-radius-5">
          No Record Found!
        </h3>
      </div>
    </ng-template>
  </p-table>
</p-dialog>
